import { Chip, type ChipProps } from "@mui/material";
import type React from "react";
import { getTagStyle } from "../utils/tag-styles";

export interface TagChipProps extends Omit<ChipProps, "label"> {
  tag: string;
  size?: "small" | "medium";
  variant?: "filled" | "outlined";
  showDeleteIcon?: boolean;
  onDelete?: (tag: string) => void;
}

export const TagChip: React.FC<TagChipProps> = ({
  tag,
  size = "small",
  variant = "outlined",
  showDeleteIcon = false,
  onDelete,
  sx,
  ...chipProps
}) => {
  const style = getTagStyle(tag);

  const handleDelete = () => {
    if (onDelete) {
      onDelete(tag);
    }
  };

  return (
    <Chip
      label={tag}
      size={size}
      variant={variant}
      onDelete={showDeleteIcon ? handleDelete : undefined}
      sx={{
        fontSize: size === "small" ? "0.75rem" : "0.875rem",
        height: size === "small" ? "24px" : "32px",
        backgroundColor: variant === "filled" ? style.color : "transparent",
        borderColor: style.borderColor,
        color: style.textColor,
        "& .MuiChip-label": {
          px: size === "small" ? 1 : 1.5,
        },
        "& .MuiChip-deleteIcon": {
          color: style.textColor,
          fontSize: size === "small" ? "0.875rem" : "1rem",
          "&:hover": {
            color: "error.main",
          },
        },
        ...sx,
      }}
      {...chipProps}
    />
  );
};
